import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { createOrder } from "../services/checkoutService";
import { useDispatch, useSelector } from "react-redux";
import OrderSummary from "./order/OrderSummary";
import Loader from "./Loader";

const CheckoutForm = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { cart, discount, taxe, shippingCost, totalItems, loader } = useSelector((state) => state.checkout);
  const orderTotal =  ((totalItems+taxe+shippingCost) - discount);

 
  const onSubmit = (data) => {
    const checkoutData = {
        cart:cart,
        data:data,
        orderTotal:orderTotal
    }
    dispatch(createOrder(checkoutData))
    console.log("Form Data Submitted:", checkoutData);
  };
  if (loader =="loading") return <Loader />
  if (loader =="error") return <div>Error</div>
  
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg"
    >
      <h2 className="text-xl font-semibold mb-4">Billing Address</h2>
      <div className="grid grid-cols-2 gap-3">
        <div className="col1">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Email *
            </label>
            <input
              type="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              })}
              className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                errors.email ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {errors.email.message}
              </p>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                First Name *
              </label>
              <input
                type="text"
                {...register("firstName", {
                  required: "First name is required",
                })}
                className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                  errors.firstName ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.firstName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.firstName.message}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Last Name *
              </label>
              <input
                type="text"
                {...register("lastName", { required: "Last name is required" })}
                className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                  errors.lastName ? "border-red-500" : "border-gray-300"
                }`}
              />
              {errors.lastName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.lastName.message}
                </p>
              )}
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Company
            </label>
            <input
              type="text"
              {...register("company")}
              className="mt-1 p-2 block w-full border rounded-md shadow-sm border-gray-300"
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Street Address *
            </label>
            <input
              type="text"
              {...register("streetAddress", {
                required: "Street address is required",
              })}
              className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                errors.streetAddress ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.streetAddress && (
              <p className="text-red-500 text-sm mt-1">
                {errors.streetAddress.message}
              </p>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Country *
              </label>
              <select
                {...register("country", { required: "Country is required" })}
                className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                  errors.country ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select</option>
                <option value="Us">USA</option>
                <option value="Fr">France</option>
                <option value="Ma">MAROC</option>
                {/* {countries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                ))} */}
              </select>
              {errors.country && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.country.message}
                </p>
              )}
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                City *
              </label>

              <select
                {...register("city", { required: "City is required" })}
                className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                  errors.country ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="">Select</option>
                <option value="newyork">New york</option>
                <option value="paris">Paris</option>
                <option value="marrakech">Marrakech</option>
                {/* {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option> 
                ))} */}
              </select>
              {errors.city && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.city.message}
                </p>
              )}
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Postcode *
            </label>
            <input
              type="text"
              {...register("postcode", {
                required: "Postcode is required",
                pattern: {
                  value: /^[0-9]{4,10}$/,
                  message: "Invalid postcode",
                },
              })}
              className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                errors.postcode ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.postcode && (
              <p className="text-red-500 text-sm mt-1">
                {errors.postcode.message}
              </p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Phone Number *
            </label>
            <input
              type="text"
              {...register("phoneNumber", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{10,15}$/,
                  message: "Invalid phone number",
                },
              })}
              className={`mt-1 p-2 block w-full border rounded-md shadow-sm ${
                errors.phoneNumber ? "border-red-500" : "border-gray-300"
              }`}
            />
            {errors.phoneNumber && (
              <p className="text-red-500 text-sm mt-1">
                {errors.phoneNumber.message}
              </p>
            )}
          </div>
        </div>
        <div className="col2">
          <div className="border border-gray-300 rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 border-b-2 border-gray-300 pb-2">
              Payment
            </h2>
            <div className="space-y-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="paypal"
                  className="mr-3"
                  defaultChecked
                />
                <span className="text-sm font-medium text-gray-700">
                  PayPal Checkout
                </span>
              </label>
              <p className="text-sm text-gray-500">
                The safer, easier way to pay.
              </p>

              <label className="flex items-center">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="bankTransfer"
                  className="mr-3"
                />
                <span className="text-sm font-medium text-gray-700">
                  Bank Transfer
                </span>
              </label>
              <p className="text-sm text-gray-500">
                Please make the payment directly to our bank account.
              </p>
            </div>
          </div>
          <div className="mt-4">
            <label className="text-xl font-semibold mb-4">Extra notes</label>
            <textarea
              className="mt-1 block w-full border-gray-300 border rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              rows="4"
            ></textarea>
          </div>
          <OrderSummary cart = {cart} discount ={discount} taxe={taxe} shippingCost ={shippingCost} totalItems={totalItems} orderTotal={orderTotal} />
        </div>
      </div>
      <button
        type="submit"
        className="mt-6 w-full py-2 bg-green-600 text-white font-bold rounded-md hover:bg-green-700"
      >
        Place Order
      </button>
    </form>
  );
};

export default CheckoutForm;
